<div class="row">
	<div class="col-lg-5 mb-3">
		<ui-title [title]="'QAR Report Chasing'"></ui-title>
		<ui-table
			[chunker]="reports.chunker" (chunked)="reports.chunkedData = $event"
			[headers]="reports.tableHeaders"
		>
			<tr *ngFor="let report of reports.chunkedData"
				[class]="reports.selectedId==report.Id?'helper-clickable active':'helper-clickable'"
				(click)="reports_select(report)"
			>
				<td>{{report.Name}}</td>
				<td>{{report.Year}}</td>
				<td class="helper-capitalize">{{report.StatusId}}</td>
				<td>{{report.CreatedDate|date}}</td>
			</tr>
		</ui-table>
	</div>
</div>
<ui-loading [loading]="chasing.loading" class="mb-3"></ui-loading>

<p class="alert alert-warning " *ngIf="reports.selectedId && chasing.count==0">
	There are no more approvers to chase for this report
</p>
<ui-table *ngIf="chasing.count>0 && reports.selectedId"
		  [chunker]="chasing.chunker" (chunked)="chasing.chunkedData = $event"
		  [headers]="chasing.tableHeaders"
		  [filters]="true"
		  [options]="{refreshButton:true,onRefreshFunction:chasing_init,onRefreshContext:self,downloadAsExcel:true,downloadAsExcelHeaders:downloadAsExcelHeaders,downloadAsExcelRowFormatter:downloadAsExcelRowFormatter}">
	<tr *ngFor="let p of chasing.chunkedData"
	>
		<td style="width:10%">{{p.SORUserOverridenApprover ? p.SORUserOverridenApprover.FirstName : p.SORUserApprover?.FirstName}}</td>
		<td style="width:10%">{{p.SORUserOverridenApprover ? p.SORUserOverridenApprover.LastName : p.SORUserApprover?.LastName}}</td>
		<td style="width:10%">{{p.SORUserOverridenApprover ? p.SORUserOverridenApprover.Email : p.SORUserApprover?.Email}}</td>
		<td style="width:10%">{{p.ChasingCount}}</td>
		<td style="width:10%">{{p.LastChasedDate|date}}</td>
		<td style="width:10%">
			<button *ngIf="chasing.canChase" class="btn btn-sm btn-{{chasing.sentEmail[p.Id]?'danger':'primary'}} mini"><span class="material-icons" style="line-height: 9px;font-size: 20px" (click)="newEmail_open(p)">email</span></button>
		</td>
		<td style="width:30%;padding:5px" (click)="chasing.activeTextarea[p.Id]=true" class="helper-clickable">

			<textarea
				(focusout)="chasing.activeTextarea[p.Id] = false"
				(focusin)="triggerResize()"
				(keydown)="triggerResize()"
				matInput
				class="form-control"
				style="line-height: 20px;font-size:14px;box-sizing:content-box;width: 90%"
				[(ngModel)]="p.ChasingNotes"
				name="chasingnotes"
				cdkTextareaAutosize
				#autosize="cdkTextareaAutosize"
				cdkAutosizeMinRows="1"
				cdkAutosizeMaxRows="50"
			></textarea>

			<ui-loading [loading]="chasing.savingComment[p.Id]"></ui-loading>
		</td>
		<td style="width:10%">
			<button *ngIf="chasing.canChase" class="btn btn-sm btn-primary" (click)="chasing_commentSave(p)" style="margin-top: 1px;">Save</button>

		</td>
	</tr>
</ui-table>

<!-- 186177 chasing for approval requests -->
<div class="row" >
	<div class="col-lg-12 mb-3">
		<ui-title [title]="'Approval Request Chasing'"></ui-title>
		<ui-table [hidden]="requests.loading"
				  [chunker]="requests.chunker" (chunked)="requests.chunkedData = $event"
				  [headers]="requests.tableHeaders"
				  [filters]="true"
				  #table
		>
			<tr *ngFor="let d of requests.chunkedData">
				<td>{{d.Type}}</td>
				<td>{{d.Reference}}</td>
				<td>{{d.CreatedDate|date}}</td>
				<td>{{d.SORUser.FirstName}} {{d.SORUser.LastName}}</td>
				<td>{{d.SORUser.Email}}</td>
				<td>{{d.StatusId}}</td>
				<td>{{d.ChasingCount}}</td>
				<td>{{d.LastChasedDate|date}}</td>
				<td>
					<span style="color:grey" *ngIf="d.NeedCountersigning && d.CounterSignedBy == null">Pending</span>
					<span style="color:grey; opacity: 0.5;" *ngIf="d.NeedCountersigning === false">N/A</span>
					<span class="green" *ngIf="d.NeedCountersigning && d.CounterSignedBy != null" [matTooltip]="d.CounterSignedBy+', '+(d.CounterSignedDate|date)">Counter Signed</span>
				</td>
				<td>
					<button class="btn btn-sm btn-primary mini"><span class="material-icons" style="line-height: 9px;font-size: 20px" (click)="newApprovalRequest_open(d)">email</span></button>
				</td>
				<td><a [routerLink]="'/p/approval-requests/'+d.Id">Open</a></td>
			</tr>
		</ui-table>
	</div>
</div>

<ui-modal [(isHidden)]="newEmail.modalHidden" [title]="newEmail.title" [lg]="true">
	<form>
		<div class="form-group row mt-3" [hidden]="newEmail.sending">
			<label class="col-lg-4 col-form-label">
				Send To
			</label>
			<div class="col-lg-8">
				<select name="towho" [(ngModel)]="newEmail.who" (ngModelChange)="newEmail_updateForManager()" class="form-control">
					<!--<option value="">User</option>
					<option value="copy-to-manager">User + copy to Manager</option>
					<option value="manager">Manager</option>-->
					<option *ngFor="let c of newEmail.sendToOption" [ngValue]="c.value">{{c.name}}</option>
				</select>
				User is : {{newEmail.userName}}<br>
				Manager is :  {{newEmail.managerName}}
			</div>
		</div>
		<div class="form-group row mt-3">
			<label class="col-lg-4 col-form-label">
				Mark as "High Importance"
			</label>
			<div class="col-lg-8">
				<mat-checkbox color="primary" [(ngModel)]="newEmail.important" [checked]="newEmail.important" name="newEmail.important"></mat-checkbox>

			</div>
		</div>
		<div class="form-group row mt-3">
			<label class="col-lg-4 col-form-label">
				Copy the audit team (copying to the email list in the settings)
			</label>
			<div class="col-lg-8">
				<mat-checkbox color="primary" [(ngModel)]="newEmail.copyAuditTeam" [checked]="newEmail.copyAuditTeam" name="newEmail.copyAuditTeam"></mat-checkbox>

			</div>
		</div>
		<div class="form-group row mt-3" [hidden]="newEmail.sending">
			<label class="col-lg-4 col-form-label">
				Additional Message
			</label>
			<div class="col-lg-8">
				<textarea class="form-control" style="border: 1px solid #ced4da" [(ngModel)]="newEmail.message" name="newemailmessage"></textarea>
			</div>
		</div>
		<div class="form-group mt-3">
			<ui-loading [loadingText]="'saving'" [loading]="newEmail.sending"></ui-loading>
			<button [hidden]="newEmail.sending" class="btn btn-primary" (click)="newEmail_send()">
				Send Email
			</button>
		</div>

	</form>
</ui-modal>

<ui-modal [(isHidden)]="newApprovalRequest.modalHidden" [title]="newApprovalRequest.title" [lg]="true">
	<form>
		<div class="form-group row mt-3" [hidden]="newApprovalRequest.sending">
			<label class="col-lg-4 col-form-label">
				Send To
			</label>
			<div class="col-lg-8">
				<!--<select name="towho" [(ngModel)]="newApprovalRequest.who" (ngModelChange)="newApprovalRequest_updateForManager()" class="form-control">
					<option value="">User</option>
					<option value="copy-to-manager">User + copy to Manager</option>
					<option value="manager">Manager</option>
					<option *ngFor="let c of newApprovalRequest.sendToOption" [ngValue]="c.value">{{c.name}}</option>
				</select>-->
				User is : {{newApprovalRequest.userName}}<br>
				Manager is :  {{newApprovalRequest.managerName}}
			</div>
		</div>
		<div class="form-group row mt-3">
			<label class="col-lg-4 col-form-label">
				Mark as "High Importance"
			</label>
			<div class="col-lg-8">
				<mat-checkbox color="primary" [(ngModel)]="newApprovalRequest.important" [checked]="newApprovalRequest.important" name="newApprovalRequest.important"></mat-checkbox>

			</div>
		</div>
		<!--
		<div class="form-group row mt-3">
			<label class="col-lg-4 col-form-label">
				Copy the audit team (copying to the email list in the settings)
			</label>
			<div class="col-lg-8">
				<mat-checkbox color="primary" [(ngModel)]="newApprovalRequest.copyAuditTeam" [checked]="newApprovalRequest.copyAuditTeam" name="newApprovalRequest.copyAuditTeam"></mat-checkbox>

			</div>
		</div>-->
		<div class="form-group row mt-3" [hidden]="newApprovalRequest.sending">
			<label class="col-lg-4 col-form-label">
				Additional Message
			</label>
			<div class="col-lg-8">
				<textarea class="form-control" style="border: 1px solid #ced4da" [(ngModel)]="newApprovalRequest.message" name="newApprovalRequestmessage"></textarea>
			</div>
		</div>
		<div class="form-group mt-3">
			<ui-loading [loadingText]="'saving'" [loading]="newApprovalRequest.sending"></ui-loading>
			<button [hidden]="newApprovalRequest.sending" class="btn btn-primary" (click)="newApprovalRequest_send()">
				Send Email
			</button>
		</div>

	</form>
</ui-modal>

<!--
{ "SORUserApprover": {
 "Id": 2109, "Login": "AVINETDESRUES", "IsActive": true, "FirstName": "Aymeric", "LastName": "VINET DESRUES", "Title": "Head of Surety-France / Directeur Caution - France", "Email": "AVINETDESRUES@tmhcc.com", "StatusId": null, "CreatedDate": "2021-07-02T14:35:47.8246936+02:00", "UpdatedDate": null, "ManagerId": 5722, "Manager": null, "OverridenManagerId": null, "OverridenManager": null
 }, "SORUserOverridenApprover": null,
 "Report": null,
 "Id": 2,
 "CreatedDate": "2021-06-25T14:22:36.303",
 "StatusId": "pending",
 "Notes": null, "CompletedBy": null, "CompletedDate": null, "CounterSignedBy": null, "CounterSignedDate": null, "LastChasedDate": null,
 "ChasingCount": 0, "SORUserApproverId": 2109, "SORUserOverridenApproverId": null, "SORUserOverridenApproverDate": null, "ReportId": 2, "Rows": null }

-->
